import React from 'react';
import { Button, Table } from 'semantic-ui-react'

/**
 * Request view component
 */
export default class RequestView extends React.Component {

	getRequestType = (request) => {
		return request.requestType === 'address' ? 'Cím felvétel' : 'Célpont hozzáadás';
	}

	getPanelChangeType = (request) => {
		if (request.frequencyRequest !== null && request.frequencyRequest !== undefined) return 'Frekvencia módosítás';
		switch (request.requestType)
		{
			case 'add': return 'Célpont hozzáadás';
			case 'remove': return 'Célpont etávolítás';
			case 'modify': return 'Célpont módosítás';
			default: return 'Ismeretlen'
		}
	}

	setRequestProcessed = (r) => {
		console.log('Set processed status for #' + r.id);
		if (r.basetype === 'panelChange')
		{
			this.props.setPanelChangeProcessed(r.id, true)
		}
		else
		{
			this.props.setRequestProcessed(r.id, true)
		}
	}

	render() {

		// Set relevant list
		const tempRequests = this.props.allRequests.length === 0 ? this.props.requests : this.props.allRequests;
		const tempPanelChanges = this.props.allPanelChanges.length === 0 ? this.props.panelChanges : this.props.allPanelChanges;

		// Map this two list into one
		let tempAll = [];

		if (tempRequests !== undefined)
		{
			tempRequests.forEach(element => {
				tempAll.push({
					id: element.id,
					basetype: 'request',
					type: this.getRequestType(element),
					visitorTerritory: element.visitorTerritory,
					name: element.name,
					address: element.postalCode + ', ' + element.city + ', ' + element.address,
					myPreferredSpecialtyHu: element.myPreferredSpecialtyHu,
					segmentation: element.segmentation,
					isProcessed: element.isProcessed,
					createdAt: element.createdAt.substring(0, 10)
				});
			});
		}

		if (tempPanelChanges !== undefined)
		{
			tempPanelChanges.forEach(element => {
				tempAll.push({
					id: element.id,
					type: this.getPanelChangeType(element),
					basetype: 'panelChange',
					visitorTerritory: element.visitorTerritory,
					name: element.name,
					address: element.postalCode !== null ? element.postalCode + ', ' + element.city + ', ' + element.address : '',
					myPreferredSpecialtyHu: element.newMyPreferredSpecialtyHu,
					segmentation: element.newSegmentation,
					isProcessed: element.isProcessed,
					createdAt: element.createdAt.substring(0, 10)
				});
			});	
		}	

		// Sort by date
		tempAll.sort(function(a,b){
			return new Date(b.createdAt) - new Date(a.createdAt);
		});		

		return  <div>
                    <Table striped selectable>
						<Table.Header>
							<Table.Row>
								<Table.HeaderCell>Igény típusa</Table.HeaderCell>
								<Table.HeaderCell>Látogatói terület</Table.HeaderCell>
								<Table.HeaderCell>Célpont neve</Table.HeaderCell>
								<Table.HeaderCell>Célpont címe</Table.HeaderCell>
								<Table.HeaderCell>Szakterület</Table.HeaderCell>
								<Table.HeaderCell>Besorolás</Table.HeaderCell>
								<Table.HeaderCell>Státusz</Table.HeaderCell>
								<Table.HeaderCell>Időpont</Table.HeaderCell>
							</Table.Row>
						</Table.Header>
						<Table.Body>
							{
							tempAll.map( (r, index) => <Table.Row key={index}>
								<Table.Cell positive={r.isProcessed}>{r.type}</Table.Cell>
								<Table.Cell positive={r.isProcessed}>{r.visitorTerritory}</Table.Cell>
								<Table.Cell positive={r.isProcessed}>{r.name}</Table.Cell>
								<Table.Cell positive={r.isProcessed}>{r.address}</Table.Cell>
								<Table.Cell positive={r.isProcessed}>{r.myPreferredSpecialtyHu}</Table.Cell>
								<Table.Cell positive={r.isProcessed}>{r.segmentation}</Table.Cell>
								<Table.Cell positive={r.isProcessed}>{r.isProcessed ? 'Kész' :  this.props.isAdmin === undefined ? 'Függő' : <Button secondary onClick={ (e) => { this.setRequestProcessed(r) } }>Kész</Button>}</Table.Cell>
								<Table.Cell positive={r.isProcessed}>{r.createdAt}</Table.Cell>
							</Table.Row>)
							}						
						</Table.Body>
					</Table>
				</div>
	}
}